import React from "react";
import ReactDOM from "react-dom";
import ReactTooltip from "react-tooltip";

export function Tooltip(props) {

    const tooltipRef = React.createRef();
    const place = props.place || 'top';
    const customProps = {};

    if (props.event) {
        customProps.event = props.event;
    }

    if (props.eventOff) {
        customProps.eventOff = props.eventOff;
    }

    if (props.globalEvent) {
        customProps.globalEvent = props.globalEvent;
    }

    if (props.globalEventOff) {
        customProps.globalEventOff = props.globalEventOff;
    }

    if (typeof props.scrollHide !== 'undefined') {
        customProps.scrollHide = props.scrollHide;
    }

    if (typeof props.resizeHide !== 'undefined') {
        customProps.resizeHide = props.resizeHide;
    }

    if (typeof props.disabled !== 'undefined') {
        customProps.disable = props.disabled;
    }

    if (typeof props.offset !== 'undefined') {
        customProps.offset = props.offset;
    }

    if (typeof props.overridePosition !== 'undefined') {
        customProps.overridePosition = props.overridePosition;
    }

    // Let react-tooltip keep its own (unlayered) styles so it handles positioning, show/hide
    // and the arrow itself, and feed it the Gaia colours/padding through its props. The Gaia
    // `ga-tooltip` class plus the few overrides in migration_gaia.scss handle the rest
    // (radius, max-width, font) with a selector specific enough to win.
    // NOTE: we deliberately do NOT add Gaia's `ga-tooltip--{place}-center` arrow modifier.
    // react-tooltip flips `place` dynamically (e.g. top -> right near a viewport edge) and
    // updates its own `place-*` class, but the Gaia modifier would stay fixed at the initial
    // `place`, so the two arrows would render in different spots (a stray square). react-tooltip
    // owns the arrow; Gaia only styles the bubble.
    const className = ['ga-tooltip', props.borderClass, props.className]
        .filter(Boolean)
        .join(' ');

    // react-tooltip renders inline in the DOM, so it inherits any ancestor stacking context
    // or reduced opacity and can end up clipped/faded behind sibling panels. It binds to its
    // trigger globally (by `data-for`/`id`) and positions with viewport-fixed coordinates, so
    // rendering it through a portal on `document.body` keeps it above everything regardless of
    // where the trigger lives in the tree.
    return ReactDOM.createPortal(
        <ReactTooltip
            role="tooltip"
            globalEventOff={"keydown"}
            place={place}
            id={props.id}
            className={className}
            delayHide={300}
            backgroundColor={"var(--ga-color-surface-action-hover)"}
            textColor={"var(--ga-color-text-on-action)"}
            arrowColor={"var(--ga-color-surface-action-hover)"}
            padding={"calc(0.4rem * 2)"}
            effect='solid'
            getContent={props.content}
            ref={tooltipRef}
            {...customProps}
        />,
        document.body
    )

}
